/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useMemo, useRef } from "react";
import Navbar from "../../components/Navbar/Navbar";
import Spinner from "../../components/Loader/Spinner";
import { useLocation, useNavigate } from "react-router-dom";
import {
  BaseAPI,
  BaseURL,
  getQualificationsList,
  getSpecialitiesList,
} from "../../services/services";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MdGpsFixed } from "react-icons/md";
import { AiFillTag } from "react-icons/ai";
import {
  HiLocationMarker,
  HiSearch,
  HiArrowCircleRight,
  HiArrowCircleLeft,
  HiOutlineLocationMarker,
  HiChevronRight,
  HiChevronLeft,
} from "react-icons/hi";
import { GoPrimitiveDot } from "react-icons/go";
import Autocomplete from "../../components/PlacesAutocomplete/Autocomplete";
import { ReactComponent as Calendar } from "../../assets/images/calendar3.svg";
import { ReactComponent as Money } from "../../assets/images/money.svg";
import { ReactComponent as Location } from "../../assets/images/location.svg";
import { ReactComponent as CirclePrimary } from "../../assets/images/circlePrimary.svg";
import { ReactComponent as CircleYellow } from "../../assets/images/circleYellow.svg";

import "react-datepicker/dist/react-datepicker.css";
import { BsFillStarFill, BsStar } from "react-icons/bs";
import Bar from "../../components/BookingInfo/Bar";
import moment from "moment";
import { FaPhoneAlt, FaUserMd, FaVideo } from "react-icons/fa";
import { getAvailbleDates } from "../../services/services";

const Home = () => {
  const selectClass = "rounded-full shadow-lg text-sm py-2 px-3";

  let navigate = useNavigate();
  const [hasInitialSpec, setHasInitialSpec] = useState(false); // gaurd for initial speciality from home

  const location = useLocation();
  const specialityFromHome = location?.state?.specialityId;
  const specialityNameFromHome = location?.state?.specialityName;

  const searchState = location?.state;

  useEffect(() => {
    if (specialityFromHome) {
      setSpec(specialityFromHome);
      setFilterSelected(true);
      setHasInitialSpec(true);
    }
  }, [specialityFromHome]);

  // document.title = "MyHCare Patients";
  document.title = "TeleSecure360 Patients";

  const user = localStorage.getItem("userData");
  const token = localStorage.getItem("token");
  // const address = JSON.parse(user).addresses[0];

  // const isGuest = localStorage.getItem("loggedInAsGuest");
  const isGuest = localStorage.getItem("loggedInAsGuest") === null ? null : localStorage.getItem("loggedInAsGuest") === "true";
  const defaultAddress = {
    latitude: 25.76905,
    longitude: -80.132234,
    address: "Miami Beach, Florida",
  };
  const parsedUser = user ? JSON.parse(user) : null;

  const address =
    // isGuest === "true"
    (isGuest === "true" || isGuest === null)
      ? defaultAddress
      : parsedUser?.addresses?.[0] || defaultAddress;

  const [isLoading, setisLoading] = useState(false);
  const [searchText, setsearchText] = useState("");
  const [locationText, setLocationText] = useState(address.address || "");
  const [doctorsList, setdoctorsList] = useState(null);
  const [cords, setcords] = useState({
    lat: address.latitude || 34.98765,
    lng: address.longitude || 75.26589,
  });

  const [searchLength, setsearchLength] = useState({
    byName: 0,
    byPlace: 0,
  });
  const [qualificationsList, setqualificationsList] = useState([]);
  const [specialitiesList, setspecialitiesList] = useState([]);
  //filters
  const [qual, setQual] = useState("");
  const [spec, setSpec] = useState("");
  const [doctorCount, setDoctorCount] = useState(0);
  const [filterSelected, setFilterSelected] = useState(false);

  //search text header
  const [text, setText] = useState(
    specialityNameFromHome || "Recommended Doctors for You",
  );

  const [recommends, setRecommends] = useState(null);

  const [showImage, setshowImage] = useState(false);
  const [doctors, setDoctors] = useState(null);

  const [showScheduleModal, setShowScheduleModal] = useState(false);
  const [doctorData, setDoctorData] = useState(null);

  const [appointmentType, setAppointmentType] = useState("");
  const [selectedData, setSelectedData] = useState({
    aptType: "",
    date: "",
    time: "",
  });

  const [currentMonth, setCurrentMonth] = useState(new Date().getMonth());
  const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

  const [selectedDate, setselectedDate] = useState("");
  const [timeSlots, setTimeSlots] = useState([]);
  const [updatedSlots, setUpdatedSlots] = useState([]);

  const [slotLoading, setSlotLoading] = useState(false);
  const [expand, setExpand] = useState(false);

  const [allSpecialities, setAllSpecialities] = useState([]);

  const divRef = useRef(null);

  const months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  const [isReady, setIsReady] = useState(false);

  useEffect(() => {
    // handle search state
    if (searchState) {
      if (searchState.searchText) {
        setsearchText(searchState.searchText);
      }

      if (searchState.lat && searchState.lng) {
        setcords({
          lat: searchState.lat,
          lng: searchState.lng,
        });
      }
    }

    // handle speciality from previous page
    if (specialityFromHome) {
      setSpec(specialityFromHome);
      setFilterSelected(true);
    }

    // ✅ mark ready AFTER handling both
    setIsReady(true);
  }, []);

  useEffect(() => {
    if (!isReady) return;

    if (spec || qual || searchText.length > 1) {
      getDoctorList(cords.lat, cords.lng);
    } else {
      getRecommendedData();
    }
  }, [spec, qual, searchText, cords, isReady]);

  const [calendarDates, setCalendarDates] = useState([]);
  //calender dates
  const getCalendarDates = (month, year) => {
    const calendarDates = [];
    const today = new Date(); // Get the current date
    const currentDate = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    ); // Extract only the date component
    const currentMonth = currentDate.getMonth();
    const currentYear = currentDate.getFullYear();

    const monthToUse =
      month < currentMonth || (month === currentMonth && year < currentYear)
        ? currentMonth
        : month;
    const yearToUse =
      month < currentMonth || (month === currentMonth && year < currentYear)
        ? currentYear
        : year;

    const totalDaysInCurrentMonth = new Date(
      yearToUse,
      monthToUse + 1,
      0,
    ).getDate();
    const offsetDays = new Date(yearToUse, monthToUse, 0).getDay();

    const insertDate = (y, m, d, insertFromStart = false) => {
      const temp = new Date(y, m, d);
      if (temp >= currentDate) {
        calendarDates[insertFromStart ? "unshift" : "push"]({
          dateString: moment(temp).format("YYYY-MM-DD"),
          date: temp.getDate(),
          month: temp.getMonth(),
          selected: false,
        });
      }
    };

    const startDay = monthToUse === currentMonth ? currentDate.getDate() : 1;

    for (let i = startDay; i <= totalDaysInCurrentMonth; i += 1) {
      insertDate(yearToUse, monthToUse, i);
    }

    for (let i = 1; calendarDates.length < 42; i += 1) {
      insertDate(yearToUse, monthToUse + 1, i);
    }

    return calendarDates;
  };

  useEffect(() => {
    if (selectedDate) {
      getTimeSlots(selectedDate);
    }
  }, [selectedDate]);

  useEffect(() => {
    setCalendarDates(getCalendarDates(currentMonth, currentYear));
  }, [currentMonth, currentYear]);

  const generateAvailability = () => {
    const currentDate = new Date();

    let dateString;
    let startOfMonth;
    let endOfMonth;

    if (currentMonth === new Date().getMonth()) {
      startOfMonth = moment(currentDate).format("YYYY-MM-DD");
      dateString = `${currentYear}-${currentMonth + 1}-01`;
      endOfMonth = moment(dateString).endOf("month").format("YYYY-MM-DD");
    } else {
      dateString = `${currentYear}-${currentMonth + 1}-01`;
      startOfMonth = moment(dateString).startOf("month").format("YYYY-MM-DD");
      endOfMonth = moment(dateString).endOf("month").format("YYYY-MM-DD");
    }

    getAvailbleDates(doctorData?._id, startOfMonth, endOfMonth).then((res) => {
      const availability = res?.data?.response?.[0]?.availability || [];

      const temp = availability.map((el) => el.availabilityDate.split("T")[0]);

      setAvailableDates(temp);
    });
  };

  useEffect(() => {
    generateAvailability();
  }, [currentMonth, currentYear, doctorData]);
  const [availableDates, setAvailableDates] = useState([]);

  const [selectedDoctorId, setSelectedDoctorId] = useState(null);
  const updateTimeSlot = (slot, i, selectedDate) => {
    //for selected one to be set as true
    let arr = [...updatedSlots];
    arr = arr.map((slot) => {
      if (slot.id === i) {
        slot.selected = !slot.selected;
      } else {
        slot.selected = false;
      }
      return slot;
    });
    setUpdatedSlots(arr);

    //update seleted data to be passed for booking
    setSelectedData({
      ...selectedData,
      bookingSlotId: slot._id,
      bookingDate: selectedDate.slice(0, 10), //Date Format
      time: `${slot.startTime} - ${slot.endTime}`,
    });
  };

  const hidePastDate = (availabilityDate, startTime) => {
    const currentDate = new Date();
    const currentHour = currentDate.getHours();
    const currentMinute = currentDate.getMinutes();

    const currentTimeInMinutes = currentHour * 60 + currentMinute;

    const convertToMinutes = (time) => {
      const [timePart, period] = time.split(/(AM|PM)/i);
      let [hours, minutes] = timePart.split(":").map(Number);

      if (period.toUpperCase() === "PM" && hours !== 12) hours += 12;
      if (period.toUpperCase() === "AM" && hours === 12) hours = 0;

      return hours * 60 + minutes;
    };

    const isSameDate =
      currentDate.toDateString() === new Date(availabilityDate).toDateString();

    if (isSameDate) {
      const slotTimeInMinutes = convertToMinutes(startTime);

      if (slotTimeInMinutes < currentTimeInMinutes) {
        return "hidden";
      }
    }

    return "";
  };
  const btnClass =
    "border border-primary py-2 px-4 cursor-pointer text-sm hover:bg-primary hover:text-white";
  //update doctor data getting doctor list  ( same as recommended)
  const updateDoctorList = (arr) => {
    // console.log(arr);
    let temp = [];
    arr.forEach((element) => {
      let obj = {};
      obj = {
        firstName: element.firstName,
        lastName: element.lastName,
        _id: element._id,
        specialities: element.specialityData ?? element?.specialities,
        addresses: element.addresses,
        profilePic: element.profilePic,
        consultationFee: element.consultationFee,
        consultationFeeAudioVideo: element.consultationFeeAudioVideo,
        consultationFeeInPerson: element.consultationFeeInPerson,
        avgRatings: element.avgRatings,
        bio: element?.bio,
        qualification: element?.qualification,
        expertize: element?.expertize,
      };

      temp.push(obj);
    });

    // console.log("new array", temp);
    if (temp.length > 0) setDoctors(temp);
    else setDoctors(null);
  };

  //getDate for esign
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, "0");
  var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
  var yyyy = today.getFullYear();

  today = mm + "/" + dd + "/" + yyyy;

  const handleSearchInput = (e) => {
    setsearchText(e.target.value);
  };

  const handleLocationInput = (e) => {
    setLocationText(e.target.value);
  };

  //Get users current location
  async function getLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(showPosition);
    } else {
    }
  }

  async function showPosition(position) {
    await setcords({
      ...cords,
      lat: position.coords.latitude,
      lng: position.coords.longitude,
    });

    reloadResult(); //for showing the instant results
  }

  const reloadResult = async () => {
    getDoctorList(cords.lat, cords.lng);
  };

  const getRecommendedData = () => {
    setisLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    BaseAPI(`${BaseURL}/patient/getRecommendedData`, requestOptions)
      .then((result) => {
        // console.log(result);
        if (result.status !== 200) {
          toast.warn(result.message);
          if (result.status === 401) {
            localStorage.clear();
            navigate("/login");
          }
        }
        setRecommends(result?.data);
        setDoctors(result?.data?.recommendedDoctors);
        updateDoctorList(result?.data?.recommendedDoctors);
        setisLoading(false);
      })
      .catch((err) => toast.error("Something went wrong!"))
      .finally(() => setisLoading(false));
  };

  const getDoctorListForReset = (lat, lng, search) => {
    setisLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    BaseAPI(
      `${BaseURL}/patient/getDoctorsList?${search?.length > 1 ? `searchUser=${search}&` : ""
      }longitude=${cords?.lng}&latitude=${cords?.lat}&radius=40&qualification=${qual
      }&speciality=${spec}&limit=100&isAdminVerified=true`,
      requestOptions,
    )
      .then((result) => {
        if (result.status !== 200) {
          toast.warn(result.message);
          if (result.status === 401) {
            localStorage.clear();
            navigate("/login");
          }
        }
        setdoctorsList(result.data);
        // setRecommends(prev => null)
        updateDoctorList(result?.data?.users);
        // setText(`${result?.data?.usersCount} doctors found near you`);
      })
      .catch((err) => toast.error("Something went wrong!"))
      .finally(() => setisLoading(false));
  };

  const getDoctorList = (lat, lng) => {
    setisLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    BaseAPI(
      `${BaseURL}/patient/getDoctorsList?${searchText.length > 1 ? `searchUser=${searchText}&` : ""
      }longitude=${cords.lng}&latitude=${cords.lat}&radius=40&qualification=${qual
      }&speciality=${spec}&limit=100&isAdminVerified=true`,
      requestOptions,
    )
      .then((result) => {
        if (result.status !== 200) {
          toast.warn(result.message);
          if (result.status === 401) {
            localStorage.clear();
            navigate("/login");
          }
        }
        setdoctorsList(result.data);
        // setRecommends(prev => null)
        updateDoctorList(result?.data?.users);
        // setText(`${result?.data?.usersCount} doctors found near you`);
      })
      .catch((err) => toast.error("Something went wrong!"))
      .finally(() => setisLoading(false));
  };

  const filterClass = `mx-4 mt-5 `;

  useEffect(() => {
    getQualificationsList()
      .then((result) => setqualificationsList(result.qualification))
      .catch((err) => console.log(err));

    getSpecialitiesList()
      .then((result) => setspecialitiesList(result.speciality))
      .catch((err) => console.log(err));

    // getRecommendedData();
  }, []);

  useEffect(() => {
    if (specialityNameFromHome && specialitiesList.length > 0) {
      const matched = specialitiesList.find(
        (item) => item.specialityName === specialityNameFromHome,
      );

      if (matched) {
        setSpec(matched._id);
        setFilterSelected(true);
      }
    }
  }, [specialityNameFromHome, specialitiesList]);



  const BookAppointment = (id) => {
    if (!selectedData?.aptType) {
      toast.error("Please select appointment mode");
      return;
    }

    if (!selectedData?.bookingSlotId) {
      toast.error("Please select a time slot");
      return;
    }

    navigate("/DoctorProfile", {
      state: {
        id: id,
        selectedSlot: selectedData,
        appointmentType: selectedData?.aptType,
      },
    });
  };

  // useEffect(() => {
  //   getDoctorList()
  // }, [qual , spec]);

  // useMemo(() => getDoctorList(), [qual , spec])

  //create new array for adding pagination
  const doctorCountArray = (arr) => {
    let paginatedArray = [];

    if (arr) {
      if (arr.slice(doctorCount, doctorCount + 10).length > 0)
        paginatedArray = arr.slice(doctorCount, doctorCount + 10);
      else setDoctorCount((prev) => prev * 0);
    }

    return paginatedArray;
  };


  const handleTypeSelect = (str) => {
    setAppointmentType(str);

    setSelectedData({
      ...selectedData,
      aptType: str,
    });
  };
  const UpdateSlotsArray = (arr) => {
    let dummySlots = arr[0].availabilityTime.map((slot, i) => {
      return {
        ...slot,
        selected: selectedData?.bookingSlotId === slot._id,
        id: i,
      };
    });

    setUpdatedSlots(dummySlots);
  };

  useEffect(() => {
    if (showScheduleModal && doctorData) {
      const today = moment().format("YYYY-MM-DD");
      setselectedDate(today);
      getTimeSlots(today);
    }
  }, [showScheduleModal, doctorData]);
  //get time slots
  const getTimeSlots = async (date) => {
    setSlotLoading(true);

    let myHeaders = new Headers({
      accept: "application/json",
      authorization: `${token}`,
    });

    var requestOptions = {
      method: "GET",
      headers: myHeaders,
    };

    console.log("-- Here selectedDAte --", selectedDate);

    BaseAPI(
      `${BaseURL}/patient/getAvailabilityTimeSlots?doctorId=${doctorData?._id}&startDateAndTime=${date}&endDateAndTime=${date}`,
    )
      .then((result) => {
        if (result.data?.availableDate === "") {
          setAvailableDates([]);
          setTimeSlots([]);
        } else if (result?.data?.response[0]?.availability !== undefined) {
          const availability = result?.data?.response[0]?.availability;

          setTimeSlots(availability);

          UpdateSlotsArray(availability);
        } else {
          setTimeSlots([]);
        }
      })
      .catch((err) => { })
      .finally(() => setSlotLoading(false));
  };

  //month changer
  const decreaseMonth = (currentMonth) =>
    currentMonth - 1 < 0 ? 11 : currentMonth - 1;
  const increaseMonth = (currentMonth) =>
    currentMonth + 1 > 11 ? 0 : currentMonth + 1;

  const scrollBtn = (direction) => {
    if (direction === "r") {
      document.getElementById("container").scrollLeft += 60;
    } else document.getElementById("container").scrollLeft -= 60;
  };

  const [selectedType, setSelectedType] = useState(null);
  const [open, setOpen] = useState(false);

  const appointmentTypes = [
    { value: "video", label: "Video ", icon: <FaVideo /> },
    { value: "audio", label: "Audio Call", icon: <FaPhoneAlt /> },
    { value: "inPerson", label: "In Person", icon: <FaUserMd /> },
  ];

  const url =
    "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png";

  return (
    // <div className="Home bg-Light-gray min-h-screen w-full">
    <div className="min-h-screen w-full pb-8">
      {/* <Navbar heading="Home" /> */}
      {/* <div className={`mx-8 py-6 mt-8`}>
        <div className="flex justify-between items-center w-auto wrap">
          <div className=" flex justify-between items-center w-auto gap-3 px-3 flex-grow">
            <div className="relative w-1/2">
              <input
                className="border rounded-lg p-2 w-full pl-8"
                placeholder="Search Doctor"
                onChange={(e) => HandleSearch(e)}
              />
              <HiSearch className="absolute left-1 bottom-2 text-lg opacity-50" />
            </div>
            <div className="relative  w-auto flex-grow">
              // <Autocomplete
              //   name={"filter"}
              //   personalInfo={cords}
              //   setpersonalInfo={setcords}
              //   Length={searchLength}
              //   setLength={setsearchLength}
              //   defaultValue={address.address}
              // />
              <input
                name="filter"
                className="border rounded-lg p-2 w-full pl-8"
                defaultValue={address.address}
                onChange={(e) => HandleSearch(e)}
              />
              <span
                onClick={async () => {
                  await getLocation();
                  setshowImage(true);
                }}
                className="text-secondary bg-white absolute right-2 top-2 text-lg cursor-pointer"
              >
                <MdGpsFixed />
              </span>
            </div>
            <button
              className="bg-primary  md:block mx-2 px-3 py-2 rounded-lg text-white"
              onClick={() => {
                setshowImage(true);
                getDoctorList(cords.lat, cords.lng);
              }}
            >

              <span className=" hidden md:inline-flex sm:hidden">Search Doctor</span>

              <HiSearch className="mx-3 text-lg inline-flex md:hidden" />

            </button>
          </div>
        </div>
      </div> */}

      <div
        className={`relative mx-9 py-20 mt-8 Background rounded-xl border border-primary`}
      >
        <div className="flex justify-center items-center w-full wrap">
          <div className="flex xl:w-3/4 md:w-4/4 w-full flex-col sm:flex-row items-center  mx-2 gap-4 px-2 py-3 rounded-xl bg-white border border-primary">
            <div className="relative  input-wrapper w-1/3">
              <input
                className="form-input text-base border-0 focus:border-0"
                placeholder=" "
                value={searchText}
                onChange={handleSearchInput}
                id="search"
                name="search"
              />

              <label
                htmlFor="search"
                className="form-input-label text-base top-1/2 -translate-y-1/2"
                style={{
                  zIndex: 1,
                  transition: "all 0.3s",
                }}
              >
                Search
              </label>

              <style>
                {`
          #search:focus + label,
          #search:not(:placeholder-shown) + label {
            transform: translateY(-120%) scale(1);
            color: #7c3aed;
          }
        `}
              </style>
            </div>
            <div className="border-l-2 border-Darkgray h-14 sm:block hidden md:block"></div>
            {/* <hr className="border-l-2 border-Darkgray w-full block sm:hidden md:hidden " /> */}

            <div className="relative ml-6 justify-center input-wrapper w-1/3">
              <input
                id="location"
                name="location"
                placeholder=" "
                className="form-input text-base border-0 focus:border-0"
                value={locationText}
                onChange={handleLocationInput}
              />
              <label
                htmlFor="location"
                className="form-input-label text-base top-1/2 -translate-y-1/2"
                style={{ zIndex: 1, transition: "all 0.3s" }}
              >
                Location
              </label>
              <style>
                {`
    #location:focus + label,
    #location:not(:placeholder-shown) + label {
      transform: translateY(-120%) scale(1);
      color: #7c3aed;
    }
  `}
              </style>
            </div>
            <button
              className="bg-primary md:block ml-auto mr-1 px-14 py-3 rounded-lg text-white"
              onClick={() => {
                setshowImage(true);
                getDoctorList(cords.lat, cords.lng);
              }}
            >
              Search
            </button>
          </div>
        </div>
        <div className="absolute -top-10 -right-11 ">
          <div className="relative">
            <CircleYellow className="w-32 h-32" />
          </div>
        </div>
        <div className="absolute -bottom-12 -left-10">
          <div className="relative">
            <CirclePrimary className="w-40 h-40" />
          </div>
        </div>
      </div>
      <div className={filterClass}>
        {/* recommended Specialiities */}
        {/* {  <div className="flex flex-col gap-4">
          <h1>Specialities</h1>
          <div>
            {recommends &&
              recommends?.recommendedSpecialities.map((item, i) => (
                <button
                  key={i}
                  className="p-2 flex flex-col bg-white rounded-lg shadow-lg items-center text-sm gap-3"
                  onClick={()=> {
                    console.log(item)
                    let temp;
                    temp = doctors.filter(doctor => {
                      return doctor.specialities.some((f) => {
                return  item._id === f._id;
  });
                    })
                    console.log( 'filtered array' , temp)
                    setDoctors(prev => temp)
                  }}
                >
                  <span className="flex justify-between items-center">
                    {" "}
                    <img
                      src={url}
                      className="h-14 rounded-full"
                      alt="logo"
                    />{" "}
                  </span>
                  <span>{item.specialityName}</span>
                </button>
              ))}
          </div>
        </div>} */}
        <div className="px-8 pt-4 flex justify-between items-center flex-col md:flex-row ">
          <div className="order-last md:order-first md:my-0 my-3">
            <h2 className="md:text-lg text-text ">{text}</h2>
          </div>
          {/* <div className="space-x-2"> */}
          <div className="flex flex-wrap gap-2">
            <select
              className={`${selectClass} w-32 md:w-auto `}
              onChange={(e) => {
                setQual(e.target.value);
                setFilterSelected(true);
                // setfilter({ ...filter, ["qualification"]: e.target.value });
                // getDoctorList();
                // console.log(qual)
              }}
            >
              <option value="none" selected disabled hidden>
                Qualification
              </option>
              <option value="">All</option>

              {qualificationsList &&
                qualificationsList.map((qualification, index) => {
                  return (
                    <option key={index} value={qualification._id}>
                      {qualification?.qualificationName}
                    </option>
                  );
                })}
            </select>
            <select
              className={selectClass}
              value={spec}
              onChange={(e) => {
                setSpec(e.target.value);
                setFilterSelected(true);
                // setfilter({ ...filter, ["speciality"]: e.target.value });
                // getDoctorList();
              }}
            >
              <option value="none" selected disabled hidden>
                Speciality
              </option>
              <option value="">All</option>
              {specialitiesList &&
                specialitiesList.map((speciality, index) => {
                  return (
                    <option key={index} value={speciality._id}>
                      {speciality.specialityName}
                    </option>
                  );
                })}
            </select>
          </div>
        </div>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        // ) : (
        //   <div className={filterClass}>
        //     {/* Recommended Doctor */}
        //     <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5 text-sm">
        //       {doctors ?
        //         doctorCountArray(doctors).map((doctor, i) => (
        //           <div className="rounded-lg bg-white justify-between p-4 flex flex-col gap-3 shadow hover:shadow-lg  transition ease-in-out">
        //             {/* image conatiner */}
        //             <div className="-mt-5 -ml-2 flex items-center rounded-full h-10 w-10">
        //               {doctor.avgRatings > 0 ? <div className="flex items-center gap-0.5">{doctor.avgRatings}<BsFillStarFill color="#f1c40f" /> </div> : <BsStar color="#f1c40f" />}
        //             </div>
        //             <div className="flex justify-center items-center">
        //               <img
        //                 className="object-cover rounded-full h-16 lg:h-24 md:h-18 w-auto"
        //                 src={doctor?.profilePic?.thumbnail || url}
        //                 alt="doctor"
        //               />
        //             </div>
        //             {/* info conatiner */}
        //             <div>
        //               <p>{`${doctor?.firstName} ${doctor?.lastName}`}</p>
        //               <p className="font-bold text-primary flex items-center gap-2">
        //                 <span><GoPrimitiveDot /></span>
        //                 {doctor?.specialities
        //                   .map((i) => i.specialityName)
        //                   .join(", ")}
        //                 {/* .join(" ,")} */}
        //               </p>
        //               <p className=" text-secondary flex items-center gap-2">
        //                 <span><AiFillTag /></span>
        //                 {/* {`$ ${doctor.consultationFee}`} */}
        //                 {`$ ${doctor.consultationFeeAudioVideo}*`}
        //               </p>
        //               <p className="opacity-60 flex gap-2 items-center">
        //                 <span><HiLocationMarker /></span>
        //                 {doctor?.addresses[0]?.address}
        //               </p>
        //             </div>
        //             {/* Call button */}
        //             <button
        //               className="btn btn-outline text-base tracking-wide hover:bg-primary hover:text-white transition ease-in-out "
        //               onClick={() => BookAppointment(doctor._id, doctor)}
        //             >
        //               Book Appointment
        //             </button>
        //           </div>
        //         )) :
        //         <p className="md:col-span-3 lg:col-span-5 col-span-2 text-center text-xl font-bold text-danger" >No Doctor Found</p>
        //       }
        //     </div>
        //     {/* {doctorsList && doctorsList?.usersCount > 0 ? (
        //       doctorCountArray( doctorsList?.users ).map((doctor, i) => {
        //         return (
        //           <div
        //             key={i}
        //             className="flex md:flex-row flex-col justify-between text-text px-2 md:px-8 py-5 border-Light-text  border-b-2"
        //           >
        //             <div className="flex items-center justify-between ">
        //               <div className="mr-10 md:mr-0">
        //                 <img
        //                   className="rounded-full h-20 w-20 lg:h-24 lg:w-24 object-cover"
        //                   src={doctor?.profilePic?.original || url}
        //                   alt="Profile"
        //                 />
        //               </div>
        //               <div className="md:mx-5">
        //                 <h2 className="text-lg font-bold px-3 md:px-0">
        //                   {doctor.fullName}
        //                 </h2>
        //                 <p>
        //                   <span key={i} className="flex items-center">
        //                     <span className="text-primary mr-3">
        //                       <GoPrimitiveDot />
        //                     </span>
        //                     {doctor.specialityData
        //                       .map((item, i) => {
        //                         return item.specialityName;
        //                       })
        //                       .join(", ")}
        //                   </span>
        //                 </p>
        //                 <p className="flex space-x-5 items-center">
        //                   <span className="text-primary mr-3">
        //                     <HiLocationMarker />
        //                   </span>
        //                   {doctor?.addresses[0]?.address}
        //                 </p>
        //               </div>
        //             </div>
        //             <div className="flex items-center justify-center flex-col mt-4 md:mt-0">
        //               <h2 className="text-primary font-bold text-right md:text-left px-4 md:px-0">
        //                 Consultation Fees : ${" "}
        //                 {doctor?.consultationFee != "" ||
        //                 doctor.consultationFee === null
        //                   ? doctor?.consultationFee
        //                   : "20"}
        //               </h2>
        //               <button
        //                 className="bg-primary text-white rounded-lg px-4 py-3 mt-2 mx-auto md:mx-0"
        //                 onClick={() => BookAppointment(doctor._id, doctor)}
        //               >
        //                 Book appointment
        //               </button>
        //             </div>
        //           </div>
        //         );
        //       })
        //     ) : (
        //       <div className="text-center text-danger text-lg font-bold">
        //         {" "}
        //         No Doctor Found For This Location{" "}
        //       </div>
        //     )} */}
        //   </div>
        // )}
        <div className={filterClass}>
          <div className="relative px-9 grid grid-cols-1 grid-rows-1 gap-5 text-sm">
            {doctors ? (
              doctorCountArray(doctors).map((doctor, i) => (
                // <div className="rounded-lg bg-white justify-between p-4 flex flex-col gap-3 shadow hover:shadow-lg  transition ease-in-out">
                //   <div className="-mt-5 -ml-2 flex items-center rounded-full h-10 w-10">
                //     {doctor.avgRatings > 0 ? <div className="flex items-center gap-0.5">{doctor.avgRatings}<BsFillStarFill color="#f1c40f" /> </div> : <BsStar color="#f1c40f" />}
                //   </div>
                //   <div className="flex justify-center items-center">
                //     <img
                //       className="object-cover rounded-full h-16 lg:h-24 md:h-18 w-auto"
                //       src={doctor?.profilePic?.thumbnail || url}
                //       alt="doctor"
                //     />
                //   </div>
                //   <div>
                //     <p>{`${doctor?.firstName} ${doctor?.lastName}`}</p>
                //     <p className="font-bold text-primary flex items-center gap-2">
                //       <span><GoPrimitiveDot /></span>
                //       {doctor?.specialities
                //         .map((i) => i.specialityName)
                //         .join(", ")}
                //     </p>
                //     <p className=" text-secondary flex items-center gap-2">
                //       <span><AiFillTag /></span>
                //       {`$ ${doctor.consultationFeeAudioVideo}*`}
                //     </p>
                //     <p className="opacity-60 flex gap-2 items-center">
                //       <span><HiLocationMarker /></span>
                //       {doctor?.addresses[0]?.address}
                //     </p>
                //   </div>
                //   <button
                //     className="btn btn-outline text-base tracking-wide hover:bg-primary hover:text-white transition ease-in-out "
                //     onClick={() => BookAppointment(doctor._id, doctor)}
                //   >
                //     Book Appointment
                //   </button>
                // </div>

                // <div className="relative p-4 flex gap-4 rounded-lg bg-white hover:bg-primaryLight2 border border-darkPrimary cursor-pointer shadow hover:shadow-lg transition ease-in-out">
                <div
                  tabIndex={0}
                  role="button"
                  onClick={() =>
                    navigate("/DoctorProfile", {
                      state: { id: doctor._id },
                    })
                  }
                  className={`relative p-4 flex flex-col md:flex-row gap-2 md:gap-3 rounded-lg cursor-pointer shadow hover:shadow-lg transition ease-in-out
  ${selectedDoctorId === doctor._id
                      ? "bg-primaryLight2 border-2 border-primary"
                      : "bg-white border border-darkPrimary hover:bg-primaryLight2"
                    }`}
                >
                  {/* <div className="w-fit pb-7"> */}
                  <div className="relative w-fit pb-7 flex justify-center md:block">
                    <img
                      className="object-cover rounded-md h-40 lg:h-52 md:h-52 w-40 md:w-48 lg:w-48"
                      // className="object-cover rounded-md h-40 sm:h-44 md:h-52 w-40 sm:w-44 md:w-48"
                      src={doctor?.profilePic?.original || doctor?.profilePic?.thumbnail || url}
                      alt="doctor"
                    />

                    {/* <div className="absolute bottom-2 w-40 flex justify-evenly items-center "> */}
                    <div className="absolute -bottom-3 left-0 w-full flex justify-center gap-6 items-center">
                      <div className="relative text-center">
                        <div className="relative border border-primary rounded-full bg-Light-gray p-3 w-10 h-10 items-center">
                          <Location className="w-4 h-4" />
                        </div>
                        <div className="relative opacity-60">
                          {doctor?.addresses[0]?.city}
                        </div>
                      </div>

                      <div className="relative">
                        <div className="relative border border-primary rounded-full bg-Light-gray w-10 h-10 p-2.5 flex items-center">
                          <Money className="w-5 h-5" />
                        </div>
                        <div className="opacity-60">{`$ ${doctor.consultationFeeAudioVideo}*`}</div>
                      </div>
                    </div>
                  </div>
                  {/* <div className="w-full"> */}
                  <div className="w-full flex flex-col ml-4 gap-2">
                    {/* <div className="flex justify-between gap-4 w-full"> */}
                    <div className="flex flex-col md:flex-row justify-between gap-1 w-full ">
                      <div className="w-full">
                        {/* <div className="flex flex-wrap gap-x-8 gap-y-4"> */}
                        <div className="flex flex-col sm:flex-row flex-wrap gap-x-8 gap-y-2">
                          <div className="text-xl">{`${doctor?.firstName} ${doctor?.lastName}`}</div>
                          <div className="text-white text-md bg-darkPrimary py-1 px-4 rounded-full w-fit shrink-0 self-start sm:self-auto">
                            {`$ ${doctor.consultationFeeAudioVideo}*`}
                          </div>
                        </div>
                        <p className="text-md text-text flex items-center gap-2">
                          {doctor?.specialities
                            .map((i) => i.specialityName)
                            .join(", ")}
                        </p>
                        {doctor.avgRatings > 0 ? (
                          <div className="flex items-center text-text gap-0.5">
                            <BsFillStarFill color="#f1c40f" />{" "}
                            {doctor.avgRatings}{" "}
                          </div>
                        ) : (
                          <BsStar color="#f1c40f" />
                        )}
                      </div>

                      {/* <div className="w-56"> */}
                      {/* <div className="w-full lg:w-56 md:w-56"> */}
                      <div className="w-full lg:w-56 md:w-56">
                        <button
                          // className="text-md py-2.5 px-6 rounded-full text-primary bg-white shadow-lg h-fit hover:bg-darkPrimary hover:text-white transition ease-in-out flex items-center gap-2"
                          className="text-md py-2.5 px-6 rounded-full text-primary bg-white shadow-lg h-fit hover:bg-darkPrimary hover:text-white transition ease-in-out flex items-center gap-2 w-full lg:w-auto justify-center shrink-0 self-start sm:self-auto"
                          onClick={(e) => {
                            e.stopPropagation();
                            setDoctorData(doctor);
                            setSelectedDoctorId(doctor._id);
                            setShowScheduleModal(true);
                          }}
                        >
                          <Calendar className="text-primary hover:text-white" />
                          View Schedule
                        </button>
                      </div>
                    </div>

                    <div className="w-full py-2">
                      {/* <div className="flex flex-wrap gap-x-20 gap-y-4 w-full"> */}
                      <div className="flex flex-col sm:flex-row flex-wrap gap-x-20 gap-y-4 w-full">
                        <div>
                          <div className="text-text text-md font-bold">
                            Expertise
                          </div>
                          <div>
                            {doctor?.expertize &&
                              doctor?.expertize?.length > 0 ? (
                              <div className="flex gap-4 flex-wrap">
                                {doctor?.expertize?.map((i) => (
                                  <div
                                    className="rounded-full px-4 py-1"
                                    style={{ background: "#F6F6F6" }}
                                  >
                                    {i}
                                  </div>
                                ))}
                              </div>
                            ) : null}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="w-full py-2">
                      {/* <div className="flex flex-wrap gap-x-20 gap-y-4 w-full"> */}
                      <div className="flex flex-col sm:flex-row flex-wrap gap-x-20 gap-y-4 w-full">
                        <div>
                          <div className="text-text text-md font-bold">
                            Education
                          </div>
                          <div>{doctor?.qualification?.qualificationName}</div>
                        </div>

                        <div>
                          <div className="text-text text-md font-bold">Bio</div>
                          <div>{doctor?.bio}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <p className="md:col-span-3 lg:col-span-5 col-span-2 text-center text-xl font-bold text-danger">
                No Doctor Found
              </p>
            )}
          </div>
          {/* {doctorsList && doctorsList?.usersCount > 0 ? (
            doctorCountArray( doctorsList?.users ).map((doctor, i) => {
              return (
                <div
                  key={i}
                  className="flex md:flex-row flex-col justify-between text-text px-2 md:px-8 py-5 border-Light-text  border-b-2"
                >
                  <div className="flex items-center justify-between ">
                    <div className="mr-10 md:mr-0">
                      <img
                        className="rounded-full h-20 w-20 lg:h-24 lg:w-24 object-cover"
                        src={doctor?.profilePic?.original || url}
                        alt="Profile"
                      />
                    </div>
                    <div className="md:mx-5">
                      <h2 className="text-lg font-bold px-3 md:px-0">
                        {doctor.fullName}
                      </h2>
                      <p>
                        <span key={i} className="flex items-center">
                          <span className="text-primary mr-3">
                            <GoPrimitiveDot />
                          </span>
                          {doctor.specialityData
                            .map((item, i) => {
                              return item.specialityName;
                            })
                            .join(", ")}
                        </span>
                      </p>
                      <p className="flex space-x-5 items-center">
                        <span className="text-primary mr-3">
                          <HiLocationMarker />
                        </span>
                        {doctor?.addresses[0]?.address}
                      </p>
                    </div>
                  </div>
                  <div className="flex items-center justify-center flex-col mt-4 md:mt-0">
                    <h2 className="text-primary font-bold text-right md:text-left px-4 md:px-0">
                      Consultation Fees : ${" "}
                      {doctor?.consultationFee != "" ||
                      doctor.consultationFee === null
                        ? doctor?.consultationFee
                        : "20"}
                    </h2>
                    <button
                      className="bg-primary text-white rounded-lg px-4 py-3 mt-2 mx-auto md:mx-0"
                      onClick={() => BookAppointment(doctor._id, doctor)}
                    >
                      Book appointment
                    </button>
                  </div>
                </div>
              );
            })
          ) : (
            <div className="text-center text-danger text-lg font-bold">
              {" "}
              No Doctor Found For This Location{" "}
            </div>
          )} */}
        </div>
      )}
      {doctorsList && doctorsList.usersCount > 10 && (
        <div
          className={`flex ${doctorCount === 0 ? "justify-end" : "justify-between"
            }  items-center m-4`}
        >
          {doctorCount !== 0 && (
            <button
              className="text-text flex items-center rounded-lg px-3 py-1 shadow gap-3 hover:shadow-lg"
              onClick={() => setDoctorCount((prev) => prev - 10)}
            >
              {" "}
              <HiArrowCircleLeft className="h-10" /> Previous
            </button>
          )}
          <button
            className="text-text flex items-center shadow px-3 py-1 rounded-lg gap-3 hover:shadow-lg"
            onClick={() => setDoctorCount((prev) => prev + 10)}
          >
            Next <HiArrowCircleRight className="h-10" />
          </button>
        </div>
      )}

      {showScheduleModal && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 50,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(0,0,0,0.6)",
            backdropFilter: "blur(4px)",
            paddingLeft: "16px",
            paddingRight: "16px",
          }}
        >
          {/* Modal Card */}
          <div className="relative w-full max-w-md bg-white rounded-2xl border border-primary shadow-xl overflow-hidden">
            {/* Close Button */}
            <button
              className="absolute right-4 top-4 text-md font-bold text-gray-600 hover:text-black"
              onClick={() => setShowScheduleModal(false)}
            >
              ✕
            </button>

            <div className="px-6 pb-6">
              {" "}
              <div className="flex justify-center">
                <div
                  className=" text-white px-8 py-2 rounded-b-xl text-lg font-semibold"
                  style={{
                    background:
                      "linear-gradient(to bottom, #8F6BCB 0%, #E6A9CF 100%)",
                    color: "white",
                  }}
                >
                  Availability
                </div>
              </div>
              <h2 className="text-center text-lg mt-4 text-gray-700">
                Book with Dr. {doctorData?.firstName} {doctorData?.lastName}
              </h2>
              <div className="flex justify-between items-center mt-6">
                <span className="text-dark text-sm w-1/2">
                  Type of Appointment
                </span>

                <div className="relative w-1/2">
                  {/* Selected */}
                  <div
                    onClick={() => setOpen(!open)}
                    className="flex items-center gap-3 bg-[#F6FAFF] px-4 py-2 rounded cursor-pointer"
                    style={{ backgroundColor: "#F6FAFF" }}
                  >
                    {selectedType ? (
                      <>
                        <span className="text-primary">
                          {selectedType.icon}
                        </span>
                        <span>{selectedType.label}</span>
                      </>
                    ) : (
                      <span className="text-dark">Select Mode</span>
                    )}
                  </div>

                  {/* Dropdown */}
                  {open && (
                    <div className="absolute top-full left-0 w-full bg-white shadow-md rounded mt-1 z-10">
                      {appointmentTypes.map((type) => (
                        <div
                          key={type.value}
                          onClick={() => {
                            setSelectedType(type);
                            handleTypeSelect(type.value);
                            setOpen(false);
                          }}
                          className="flex items-center gap-3 px-4 py-2 hover:bg-gray-100 cursor-pointer"
                        >
                          <span className="text-primary">{type.icon}</span>
                          <span>{type.label}</span>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>
              <hr className="mt-3 border-gray-200" />
              <div className="w-full flex justify-center">
                <div className="flex space-x-4">
                  <div className="flex mt-3 space-x-3 items-center">
                    <button
                      onClick={() => {
                        if (currentYear >= new Date().getFullYear()) {
                          if (
                            currentYear === new Date().getFullYear() &&
                            currentMonth - 1 < new Date().getMonth()
                          ) {
                            console.log("not allowed");
                          } else setCurrentMonth(decreaseMonth(currentMonth));
                        }
                      }}
                    >
                      {" "}
                      <HiChevronLeft className="cursor-pointer text-black" />{" "}
                    </button>
                    <span className="font-bold">{months[currentMonth]}</span>
                    <button
                      onClick={() =>
                        setCurrentMonth(increaseMonth(currentMonth))
                      }
                    >
                      {" "}
                      <HiChevronRight className="cursor-pointer text-black" />{" "}
                    </button>
                  </div>
                  <div className="flex mt-3 space-x-3 items-center">
                    <span
                      onClick={() => {
                        if (currentYear > new Date().getFullYear())
                          setCurrentYear((prev) => prev - 1);
                      }}
                    >
                      {" "}
                      <HiChevronLeft className="cursor-pointer" />{" "}
                    </span>
                    <span className="font-bold">{currentYear}</span>
                    <span onClick={() => setCurrentYear((prev) => prev + 1)}>
                      {" "}
                      <HiChevronRight className="cursor-pointer" />{" "}
                    </span>
                  </div>
                </div>
              </div>
              <div className="flex items-center">
                <span
                  className=" text-lg font-bold cursor-pointer"
                  onClick={() => scrollBtn("l")}
                >
                  <HiChevronLeft />
                </span>
                <div
                  className="w-full flex items-center gap-1 overflow-x-scroll py-2 mt-2 custom-scroll"
                  id="container"
                >
                  {/*  eslint-disable-next-line array-callback-return */}
                  {calendarDates.map((date, i) => {
                    const isAvailable = availableDates.includes(
                      date.dateString,
                    );
                    if (date.month === currentMonth) {
                      return (
                        <button
                          key={date.dateString}
                          disabled={!isAvailable}
                          onClick={() => {
                            getTimeSlots(date?.dateString);
                            setselectedDate(date?.dateString);
                          }}
                          className={`text-text w-42 transition border rounded-lg py-3 px-4 mx-2 ${selectedDate === date?.dateString
                              ? "bg-primary text-white border-primary"
                              : isAvailable
                                ? "bg-white hover:bg-Light-Primary-400 border-text"
                                : "bg-gray border-none cursor-not-allowed"
                            }`}
                        >
                          <p className="text-sm mt-2 text-center">
                            {moment(date.dateString).format("ddd")}
                          </p>
                          <div className="flex items-center gap-1">
                            <div> {date.date}</div>
                            <div> {moment(date.dateString).format("MMM")} </div>
                          </div>
                        </button>
                      );
                    }
                  })}
                </div>
                <span
                  className=" text-lg font-bold cursor-pointer"
                  onClick={() => scrollBtn("r")}
                >
                  <HiChevronRight />
                </span>
              </div>
              <div className="text-text w-full">
                <div
                  // className={`w-100%  h-auto ${expand ? "md:h-auto" : " md:h-44"} overflow-scroll`}
                  className={`w-100% h-36 overflow-scroll`}
                >
                  {slotLoading && (
                    <h2 className=" text-grey-400 text-lg mt-2 text-center font-bold">
                      Loading ...
                    </h2>
                  )}

                  {/* ----slots-------- */}
                  {!slotLoading && timeSlots.length > 0
                    ? timeSlots.map((item, i) => {
                      const currentDate = new Date()
                        .toISOString()
                        .split("T")[0];
                      // eslint-disable-next-line no-lone-blocks
                      return (
                        <div key={i}>
                          {/* <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-1"> */}
                          <div className="grid gap-2">
                            {updatedSlots &&
                              updatedSlots.map((slot, i) => {
                                return (
                                  <span
                                    onClick={() => {
                                      updateTimeSlot(
                                        slot,
                                        i,
                                        item.availabilityDate,
                                      );
                                      if (divRef.current) {
                                        divRef.current.scrollIntoView({
                                          behavior: "smooth",
                                        });
                                      }
                                    }}
                                    className={`${btnClass} ${hidePastDate(item.availabilityDate, slot.startTime)} ${slot.selected &&
                                      "bg-primary text-white text-sm whitespace-nowrap"
                                      } rounded-full text-center mx-4`}
                                    key={slot?._id}
                                  >
                                    {`${slot.startTime} - ${slot.endTime}`}
                                  </span>
                                );
                              })}
                          </div>
                        </div>
                      );
                    })
                    : !slotLoading && (
                      <h1 className="text-center text-lg font-bold mt-4">
                        No Slots Available
                      </h1>
                    )}
                </div>
              </div>
              <div className="w-full flex justify-center ">
                <button
                  disabled={!selectedData?.bookingSlotId}
                  className={`text-center text-base rounded-full py-3 px-6 transition
    ${selectedData?.bookingSlotId
                      ? "bg-primary text-white"
                      : "bg-bluishPurple text-gray-500 cursor-not-allowed"
                    }`}
                  onClick={() => BookAppointment(doctorData._id)}
                >
                  Book with Dr. {doctorData?.firstName} {doctorData?.lastName}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
